/** GA4 measurement ID — English production site only (see index.html hostname guard). */
export const EN_GA_MEASUREMENT_ID = 'G-LXQ5HHNSNM'

const PRODUCTION_HOSTS = new Set(['algomori.com', 'www.algomori.com'])

export function isEnProductionHost() {
  if (typeof window === 'undefined') return false
  return PRODUCTION_HOSTS.has(window.location.hostname)
}

/**
 * SPA route changes — safe on every navigation; no-ops off production or before gtag loads.
 */
export function trackEnGaPageView(pathnameAndSearch) {
  if (!isEnProductionHost()) return
  if (typeof window.gtag !== 'function') return
  const path = pathnameAndSearch || window.location.pathname + window.location.search
  window.gtag('config', EN_GA_MEASUREMENT_ID, {
    page_path: path,
  })
}
